export class CookieError extends Error {
  readonly reporter = "client:cookie"
}
export class DomainError extends Error {
  readonly reporter = "client:domain"
}
